import { Carousel } from "@mantine/carousel";
import Autoplay from "embla-carousel-autoplay";
import Image from "next/image";
import * as React from "react";
import { FileStorage } from "@/services/FileService";
import css from "./ImageBlock.module.css";

interface ImageBlockProps {
  images: FileStorage[] | undefined;
  onClick?: () => void;
  /** @default "default" */
  variant?: "default" | "short";
}

export function ImageBlock({
  images,
  onClick,
  variant = "default",
}: ImageBlockProps) {
  const autoplay = React.useRef(
    Autoplay({ delay: getRandomIntInclusive(3000, 5000) })
  );

  const sizes = React.useMemo(() => {
    switch (variant) {
      case "default":
        return { height: 400, width: 945 };
      case "short":
        return { height: 250, width: 400 };

      default:
        return { height: 100, width: 100 };
    }
  }, [variant]);

  if (!images || images.length === 0) {
    return null;
  }

  if (images.length === 1) {
    return (
      <Image
        className={css.image}
        onClick={onClick}
        src={images[0].url}
        alt={images[0].description}
        height={sizes.height}
        width={sizes.width}
      />
    );
  }

  return (
    <Carousel
      withIndicators
      w="945px"
      height="450px"
      classNames={css}
      plugins={[autoplay.current]}
      onMouseEnter={autoplay.current.stop}
      onMouseLeave={autoplay.current.reset}
      loop
      align="start"
    >
      {images.map((img) => (
        <Carousel.Slide key={img.name} data-id={1}>
          <Image
            className={css.image}
            onClick={onClick}
            title={img.title}
            src={img.url}
            alt={img.description}
            height={sizes.height}
            width={sizes.width}
          />
        </Carousel.Slide>
      ))}
    </Carousel>
  );
}

function getRandomIntInclusive(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min);
}
